import React from 'react'
import ButtonCustom from '../../atoms/button/ButtonCustom'
import styles from './RecommendedVendorsCard.module.scss'

export default function RecommendedVendorsCard({
	imageSrc,
	imageAlt,
	title,
	description,
}) {
	return (
		<div className={styles.recommendedVendorsCard}>
			<figure className={styles.recommendedVendorsCardImage}>
				<img src={imageSrc} alt={imageAlt} />
			</figure>
			<div className={styles.recommendedVendorsCardContent}>
				<div className={styles.recommendedVendorsCardContentText}>
					<h4>{title}</h4>
					<p>{description}</p>
				</div>
				<ButtonCustom variant="outlined">
					Details
					<img src="/images/ArrowRight.svg" alt="ArrowRight" />
				</ButtonCustom>
			</div>
		</div>
	)
}
